module.exports = __webpack_public_path__ + "img/immy.4eaaca3c.jpg";